import React, { useEffect, useState } from 'react';
import { IoMdClose } from 'react-icons/io';
import { useLazyQuery, useQuery } from '@apollo/client';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { ENVIRONMENTS } from '../../../Constants/constants';
import {
  GET_CONTEXTS,
  DELETE_URL_FROM_ALL_CONTEXTS,
} from '../../../GraphQL/ManageUrls/TRFX/Queries';
import { useNavigate } from 'react-router-dom';

function DeleteUrl() {
  const navigate = useNavigate();
  const [env, setEnvironment] = useState('dev');
  const [url, setUrl] = useState('');
  const [urls, setUrls] = useState([]);
  const [formErrors, setFormErrors] = useState({});

  const { refetch } = useQuery(GET_CONTEXTS, {
    notifyOnNetworkStatusChange: true,
    variables: { env },
    onCompleted: (data) => {
      const rawUrls = data.contextFindMany.reduce((acc, c) => {
        const temp = [...acc];
        for (const u of c.urls) {
          if (!acc.includes(u)) temp.push(u);
        }
        return temp;
      }, []);

      setUrls(rawUrls.sort());
    },
  });

  useEffect(() => {
    refetch();
  }, [env]);

  const [deleteUrl] = useLazyQuery(DELETE_URL_FROM_ALL_CONTEXTS, {
    onCompleted: () => {
      window.hideMessage();
      setUrl('');
      window.flash('Url was deleted successfully.', 'success');
    },
    onError: (error) => {
      window.hideMessage();
      window.flash(`Delete url failed. Error: ${error.message}`, 'error');
    },
  });

  const validateForm = () => {
    const errors = {};

    if (!env) {
      errors.env = '*Please select an environment';
    }

    if (!url) {
      errors.url = '*Please select a URL';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const onSubmit = (event) => {
    event.preventDefault();

    if (!validateForm()) {
      window.hideMessage();
      return;
    }

    window.showMessage('Loading', 'loading');
    deleteUrl({
      variables: {
        env,
        url,
      },
    });
  };

  return (
    <div className='d-flex justify-content-center'>
      <div className='e-card' style={{ width: '50%' }}>
        <div className='ml-auto'>
          <a
            href='/trfx-run-tests'
            style={{ textDecoration: 'none', color: 'gray' }}
          >
            <IoMdClose size='20' className='mt-2 mr-2' />
          </a>
        </div>
        <div className='e-card-header mt-2' style={{ width: '100%' }}>
          <div className='e-card-header-caption'>
            <div className='e-card-header-title d-flex justify-content-center'>
              <h5>Delete url from context</h5>
            </div>
          </div>
        </div>
        <div className='e-card-content'>
          <form id='deleteUrlForm' onSubmit={(event) => onSubmit(event)}>
            <div className='d-flex' style={{ columnGap: '18px' }}>
              <div className='form-group' style={{ width: '50%' }}>
                <div className='e-float-input'>
                  <Dropdown
                    id='env'
                    placeholder='Select environment'
                    value={env}
                    options={ENVIRONMENTS}
                    optionLabel='text'
                    optionValue='value'
                    onChange={(e) => setEnvironment(e.value)}
                    className={formErrors.env ? 'p-invalid' : ''}
                  />
                  {formErrors.env && (
                    <small className='p-error'>{formErrors.env}</small>
                  )}
                </div>
              </div>
            </div>
            <div className='form-group'>
              <div className='e-float-input'>
                <Dropdown
                  id='url'
                  value={url}
                  options={urls}
                  onChange={(e) => setUrl(e.value)}
                  filter
                  placeholder='Select URL'
                  className={formErrors.url ? 'p-invalid' : ''}
                />
                {formErrors.url && (
                  <small className='p-error'>{formErrors.url}</small>
                )}
              </div>
            </div>
            <div className='d-flex justify-content-center mt-5'>
              <Button
                type='button'
                label='Cancel'
                icon='pi pi-times'
                className='p-button-outlined mr-2'
                onClick={() => navigate('/trfx-run-tests')}
              />
              <Button
                type='submit'
                label='Accept'
                icon='pi pi-check'
                className='p-button-primary'
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default DeleteUrl;
